import React from "react";
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import logo from "./logo.jpeg";
import Background_video from "./Background_video.mp4"; // Add your video file in src folder
import Footer from './Footer/Footer';
import Home from './Home/Home';
import ContactUs from "./ContactUs/ContactUs";
import { FaHome, FaBuilding, FaPhone, FaBars, FaTimes } from "react-icons/fa";
import AboutUs from "./AboutUs/AboutUs";
import { useState } from "react";
import ScrollToTop from "./ScrollToTop";

function App() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="App">
            <Router>
                <ScrollToTop />
                <Helmet>
                    <title>SAI BHAVANA REALTY</title>
                </Helmet>

                {/* ================= HERO SECTION ================= */}
                <div className="hero-container">

                    {/* Background Video */}
                    <video autoPlay loop muted playsInline className="background-video">
                        <source
                            src={Background_video}
                            type="video/mp4" />
                    </video>

                    {/* Dark Overlay */}
                    <div className="overlay"></div>

                    {/* Top Navbar */}
                    <header className="top-header">
                        <Link className="brand" to="/">
                            <img src={logo} alt="logo" className="logo-img" />
                            <div className="brand-text">
                                SAI BHAVANA REALTY
                                <small>Property Purchase and Sale</small>
                            </div>
                        </Link>

                        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                            {menuOpen ? <FaTimes /> : <FaBars />}
                        </div>

                        <nav className={`menu ${menuOpen ? 'active' : ''}`}>
                            <Link to="/" className="menu-item">
                                <FaHome /> <span>Home</span>
                            </Link>

                            <Link to="/about" className="menu-item">
                                <FaBuilding /> <span>About Us</span>
                            </Link>

                            <Link to="/contact" className="menu-item">
                                <FaPhone /> <span>Contact Us</span>
                            </Link>
                        </nav>
                    </header>

                    {/* Center Content */}
                    <div className="hero-content">
                        <h1>Find Your Dream Property</h1>
                        <p>Buy | Sell | Invest in Premium Real Estate</p>

                    </div>

                </div>

                {/* Routes */}
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/contact' element={<ContactUs />} />
                    <Route path='/about' element={<AboutUs />} />
                </Routes>

                <Footer />
            </Router>
        </div>
    );
}

export default App;